import { render, staticRenderFns } from "./teamsForT4OrT6OrT8.vue?vue&type=template&id=53107ee2&scoped=true"
import script from "./teamsForT4OrT6OrT8.vue?vue&type=script&lang=js"
export * from "./teamsForT4OrT6OrT8.vue?vue&type=script&lang=js"
import style0 from "./teamsForT4OrT6OrT8.vue?vue&type=style&index=0&id=53107ee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53107ee2",
  null
  
)

export default component.exports